import { useEffect } from 'react';
import { insertTrackableHTML } from 'js/utils/DOM.util';
import { tagTypeService } from 'js/services/tagType.service';
import { TAG_TYPE } from 'js/components/system/TagManager/constants';

const html = ({
    application,
    applicationID,
    ezPushFile,
    pathToEzPushScript,
    language,
    enableLog
}) => {
    return `<script>
(function() {
const registerPushApplication = function() {
  if (!window.EzPush || !window.EzPush.pushToken) {
    return;
  }
  var { pushToken: pushId, hwid: deviceId } = window.EzPush;
  Playtech.API.server.registerPushApplication({
    pushId,
    deviceId,
    application: '${application}'
  });
};

Playtech.on(Playtech.Events.LOGGED_IN, registerPushApplication);
Playtech.API.common.getScript(${pathToEzPushScript
    ? `'${pathToEzPushScript}'`
    : '\'https://ezpush-stg.techonlinecorp.com/SDK/v2/ezpush-client.js\''})
  .then(() => window.EzPush.init({
    applicationId: '${applicationID}', // ID of application from ezpush admin
    subscribeOnInit: true,
    language: ${language ? `'${language}'` : `'${window.navigator.language}'`}, // taken from from window.navigator.language by default
    logEnabled: ${enableLog ? 'true' : 'false'},
    serviceWorkerUrl: ${ezPushFile ? `'${ezPushFile}'` : '\'/library/ezpush/ezpush-sw.js\''}, // optional, 'ezpush-sw.js' by default, Service-Worker-Allowed HTTP header required
  }))
  .then(() => {
    console.log('[EzPush] You are subscribed to push notifications.');
    if (Playtech.API.user.isLoggedIn()) {
      registerPushApplication();
    }
  }).catch((error) => {
    console.log('[EzPush] Failed to subscribe to push notifications: ', error);
  });
})();
</script>`;
};

export const EzPush = ({ config, tagName }) => {
    useEffect(() => {
        return insertTrackableHTML({
            tagName,
            selector: 'head',
            html: html(config),
            wrapperComment: 'EzPush'
        });
    }, [config, tagName]);

    return null;
};

tagTypeService.registerTagType({ [TAG_TYPE.ezPush]: EzPush });
